export const InfoTestTeacherBannerTranslations = {
  NEW_TEST_MODES: {
    es: '¡Hemos renovado los tests!',
    en: 'We have updated the tests!',
    cat: 'Hem renovat els tests!',
    eus: 'Testak berritu ditugu!',
    pt: 'Testes atualizados!'
  },
  DISCOVER_NEW_TEST_MODES: {
    es: 'Descubre los nuevos modos de práctica y cómo puedes generarlos fácilmente (¡incluso con IA!) para mejorar la experiencia de aprendizaje.',
    en: 'Discover the new practice modes and how you can easily generate them (even with AI!) to enhance the learning experience.',
    cat: 'Descobreix els nous modes de pràctica i com els pots generar fàcilment (fins i tot amb IA!) per millorar l’experiència d’aprenentatge.',
    eus: 'Eskubide gehiago eman zure ikastarok. Aukeratu zure hobetu gisa eta erakutsi zer modu duzu.',
    pt: 'Descobre os novos modos de prática e como podes gerá-los facilmente (até com IA!) para melhorar a experiência de aprendizagem.'
  },
  CREATE_TEST: {
    es: 'Crear test',
    en: 'Create test',
    cat: 'Crear test',
    eus: 'Test sortu',
    pt: 'Criar teste'
  },
  LEARN_MORE: {
    es: 'Saber más',
    en: 'Learn more',
    cat: 'Saber més',
    eus: 'Eskubide gehiago',
    pt: 'Saber mais'
  }
};
